import { createMuiTheme, ThemeOptions } from "@material-ui/core/styles";
import { orange } from "@material-ui/core/colors";

const palette = {
    primary: { main: '#011433' },
    secondary: { main: '#CFD8DC' }
  };
  
export const appTheme =  createMuiTheme({ palette });